import { Footer } from '@components';
import { useScreenSize, useScrollToTop } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { PlatformInfoListPageTemplate } from '@templates';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const PrivacyPolicyPage = () => {
  useScrollToTop();
  const { i18n } = useTranslation();
  const { state } = useLocation();
  const { isMobile } = useScreenSize();

  const backButton =
    state?.from === 'auth'
      ? i18n.t('PrivacyPolicy.BackButtonTitles.SignUp')
      : i18n.t('PrivacyPolicy.BackButtonTitles.Back');

  return (
    <>
      <PlatformInfoListPageTemplate
        backButtonTitle={backButton}
        pageTitle={i18n.t('PrivacyPolicy.Title')}
        subtitle={i18n.t('PrivacyPolicy.Subtitle')}
        updateDate={i18n.t('PrivacyPolicy.UpdateDate')}
      >
        <Flex flexDirection="column" mt={24} p={isMobile ? 0 : 24}>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.1')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.1-1')}
              </Typography>
            </StyledLi>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.1-2')}
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.2')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.2-1')}
              </Typography>
            </StyledLi>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.2-2')}
              </Typography>
            </StyledLi>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.2-3')}
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.3')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.3-1')}
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.4')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.4-1')}
              </Typography>
            </StyledLi>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.4-2')}
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.5')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.5-1')}
              </Typography>
            </StyledLi>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.5-2')}
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.6')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.6-1')}
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.7')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.7-1')}
              </Typography>
            </StyledLi>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.7-2')}
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.8')}
          </Typography>
          <ul style={{ paddingLeft: 0 }}>
            <StyledLi>
              <Typography
                color={theme.colors.white[100]}
                variant="MS-semiregular-s16-lh21"
              >
                {i18n.t('PrivacyPolicy.8-1')}{' '}
                <a
                  href={`mailto:${i18n.t('PrivacyPolicy.Contact')}`}
                  style={{
                    color: theme.colors.schoolBusYellow[100],
                    textDecoration: 'none',
                  }}
                >
                  {i18n.t('PrivacyPolicy.Contact')}
                </a>
              </Typography>
            </StyledLi>
          </ul>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {i18n.t('PrivacyPolicy.9')}
          </Typography>
        </Flex>
      </PlatformInfoListPageTemplate>
      <Footer />
    </>
  );
};

const StyledLi = styled.li`
  margin-left: 24px;
`;

export default PrivacyPolicyPage;
